import { render, staticRenderFns } from "./LegForm.vue?vue&type=template&id=4c4e8d76&scoped=true&"
import script from "./LegForm.vue?vue&type=script&lang=js&"
export * from "./LegForm.vue?vue&type=script&lang=js&"
import style0 from "./LegForm.vue?vue&type=style&index=0&id=4c4e8d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e8d76",
  null
  
)

export default component.exports